// HKDSE Type B (記敘散文) Quiz Data - (B1, B2, B3)
// 系統化分類測驗數據，為後續 Supabase 後端數據遷移做準備

const hkdseTypeBQuizData = {
    // B1: 《論語》論仁
    'hkdse-b1-analects-ren': {
              keyPoints: {
          title: '重點概念',
          questions: [
            {
              id: 'b1-kp-1',
              question: '《論語》論仁的核心思想是什麼？',
              options: [
                'A. 仁的具體內容和表現',
                'B. 克己復禮的修養要求',
                'C. 仁者的品格特徵',
                'D. 以上皆是'
              ],
              correctAnswer: 'D',
              explanation: '《論語》論仁從個人修養以及待人處事兩方面，講述仁的內容，以及仁者對待仁的表現。',
              points: 10
            },
            {
              id: 'b1-kp-2',
              question: '「克己復禮」體現了什麼？',
              options: [
                'A. 自我約束',
                'B. 禮儀規範',
                'C. 道德修養',
                'D. 以上皆是'
              ],
              correctAnswer: 'D',
              explanation: '「克己復禮」體現了自我約束、禮儀規範和道德修養的要求。',
              points: 10
            },
            {
              id: 'b1-kp-3',
              question: '仁者的品格特徵是什麼？',
              options: [
                'A. 安於實行仁德',
                'B. 不會違背仁德',
                'C. 以仁德為根本',
                'D. 以上皆是'
              ],
              correctAnswer: 'D',
              explanation: '仁者安於實行仁德，無論在任何時候都不會違背仁德，以仁德為根本。',
              points: 10
            }
          ]
        },
      argumentationMethods: {
        title: '論證手法',
        questions: [
          {
            id: 'b1-am-1',
            question: '文章如何論證「國家利益高於個人恩怨」？',
            options: [
              'A. 通過對比手法',
              'B. 通過具體事例',
              'C. 通過比喻論證',
              'D. 通過反證法'
            ],
            correctAnswer: 'B',
            explanation: '文章通過廉頗和藺相如的具體事蹟，生動地論證了國家利益高於個人恩怨的主題。',
            points: 10
          },
          {
            id: 'b1-am-2',
            question: '司馬遷如何突出藺相如的機智？',
            options: [
              'A. 直接描述',
              'B. 通過對話展現',
              'C. 通過行動描寫',
              'D. 通過對比手法'
            ],
            correctAnswer: 'C',
            explanation: '司馬遷通過描寫藺相如在完璧歸趙、澠池之會等事件中的具體行動，展現其機智。',
            points: 10
          }
        ]
      },
      writingTechniques: {
        title: '寫作手法',
        questions: [
          {
            id: 'b1-wt-1',
            question: '文章主要採用什麼敘事手法？',
            options: [
              'A. 順敘',
              'B. 倒敘',
              'C. 插敘',
              'D. 平敘'
            ],
            correctAnswer: 'A',
            explanation: '文章主要採用順敘手法，按時間順序記述廉頗和藺相如的事蹟。',
            points: 10
          },
          {
            id: 'b1-wt-2',
            question: '司馬遷如何塑造人物形象？',
            options: [
              'A. 通過外貌描寫',
              'B. 通過語言和行動',
              'C. 通過心理描寫',
              'D. 通過環境描寫'
            ],
            correctAnswer: 'B',
            explanation: '司馬遷主要通過人物的語言和行動來塑造鮮明的人物形象。',
            points: 10
          }
        ]
      },
      rhetoricalDevices: {
        title: '修辭手法',
        questions: [
          {
            id: 'b1-rd-1',
            question: '「完璧歸趙」運用了什麼修辭手法？',
            options: [
              'A. 比喻',
              'B. 借代',
              'C. 誇張',
              'D. 對比'
            ],
            correctAnswer: 'B',
            explanation: '「完璧歸趙」中的「璧」借代和氏璧，運用了借代修辭手法。',
            points: 10
          },
          {
            id: 'b1-rd-2',
            question: '文章中的對話描寫有什麼作用？',
            options: [
              'A. 推動情節發展',
              'B. 展現人物性格',
              'C. 增強真實感',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '對話描寫既能推動情節發展，又能展現人物性格，還能增強敘事的真實感。',
            points: 10
          }
        ]
      }
    },
  
    // B2: 《論語》論孝
    'hkdse-b2-analects-filial': {
      keyPoints: {
        title: '重點概念',
        questions: [
          {
            id: 'b2-kp-1',
            question: '《師說》的核心論點是什麼？',
            options: [
              'A. 師者，所以傳道授業解惑也',
              'B. 弟子不必不如師，師不必賢於弟子',
              'C. 聞道有先後，術業有專攻',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '《師說》的核心論點包括師的定義、師生關係的平等性以及學習的普遍性。',
            points: 10
          },
          {
            id: 'b2-kp-2',
            question: '韓愈認為什麼是「師」的定義？',
            options: [
              'A. 傳授知識的人',
              'B. 傳道授業解惑的人',
              'C. 有學問的人',
              'D. 年長的人'
            ],
            correctAnswer: 'B',
            explanation: '韓愈明確指出「師者，所以傳道授業解惑也」，強調師的三大職責。',
            points: 10
          },
          {
            id: 'b2-kp-3',
            question: '文章強調的學習態度是什麼？',
            options: [
              'A. 謙虛好學',
              'B. 不恥下問',
              'C. 尊師重道',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '文章強調謙虛好學、不恥下問、尊師重道的學習態度。',
            points: 10
          }
        ]
      },
      argumentationMethods: {
        title: '論證手法',
        questions: [
          {
            id: 'b2-am-1',
            question: '韓愈如何論證「弟子不必不如師」？',
            options: [
              'A. 通過對比論證',
              'B. 通過舉例論證',
              'C. 通過比喻論證',
              'D. 通過反證法'
            ],
            correctAnswer: 'B',
            explanation: '韓愈通過孔子向郯子、萇弘、師襄、老聃學習的具體例子來論證。',
            points: 10
          },
          {
            id: 'b2-am-2',
            question: '文章運用了什麼論證結構？',
            options: [
              'A. 總分總',
              'B. 分總分',
              'C. 並列式',
              'D. 遞進式'
            ],
            correctAnswer: 'A',
            explanation: '文章先提出總論點，然後分層論證，最後總結，採用總分總的結構。',
            points: 10
          }
        ]
      },
      writingTechniques: {
        title: '寫作手法',
        questions: [
          {
            id: 'b2-wt-1',
            question: '文章主要採用什麼文體？',
            options: [
              'A. 記敘文',
              'B. 議論文',
              'C. 說明文',
              'D. 抒情文'
            ],
            correctAnswer: 'B',
            explanation: '《師說》是一篇議論文，主要論述師道的重要性和師生關係。',
            points: 10
          },
          {
            id: 'b2-wt-2',
            question: '韓愈如何增強論證的說服力？',
            options: [
              'A. 運用排比句',
              'B. 運用反問句',
              'C. 運用對比',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '韓愈運用排比句、反問句、對比等多種手法增強論證的說服力。',
            points: 10
          }
        ]
      },
      rhetoricalDevices: {
        title: '修辭手法',
        questions: [
          {
            id: 'b2-rd-1',
            question: '「師者，所以傳道授業解惑也」運用了什麼修辭？',
            options: [
              'A. 排比',
              'B. 對偶',
              'C. 設問',
              'D. 比喻'
            ],
            correctAnswer: 'A',
            explanation: '這句話運用了排比修辭，三個動詞並列，節奏鮮明。',
            points: 10
          },
          {
            id: 'b2-rd-2',
            question: '文章中的反問句有什麼作用？',
            options: [
              'A. 增強語氣',
              'B. 突出重點',
              'C. 引發思考',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '反問句既能增強語氣，又能突出重點，還能引發讀者思考。',
            points: 10
          }
        ]
      }
    },
    // B3: 《論語》論君子
    'hkdse-b3-analects-gentleman': {
      keyPoints: {
        title: '重點概念',
        questions: [
          {
            id: 'b3-kp-1',
            question: '《始得西山宴遊記》的核心主題是什麼？',
            options: [
              'A. 山水之美',
              'B. 心靈的解放與超越',
              'C. 政治失意的苦悶',
              'D. 自然與人文的融合'
            ],
            correctAnswer: 'B',
            explanation: '文章通過描寫西山之遊，表達了作者心靈的解放與超越，從政治失意中獲得精神自由。',
            points: 10
          },
          {
            id: 'b3-kp-2',
            question: '柳宗元在文中表達了什麼人生態度？',
            options: [
              'A. 消極避世',
              'B. 積極樂觀',
              'C. 超然物外',
              'D. 憤世嫉俗'
            ],
            correctAnswer: 'C',
            explanation: '柳宗元通過西山之遊，展現了超然物外的人生態度，在自然中獲得心靈的寧靜。',
            points: 10
          },
          {
            id: 'b3-kp-3',
            question: '「始得」二字在文中有什麼含義？',
            options: [
              'A. 第一次獲得',
              'B. 終於獲得',
              'C. 開始獲得',
              'D. 重新獲得'
            ],
            correctAnswer: 'B',
            explanation: '「始得」表示終於獲得，強調了作者經過長期尋找後才找到心靈寄託的珍貴。',
            points: 10
          }
        ]
      },
      argumentationMethods: {
        title: '論證手法',
        questions: [
          {
            id: 'b3-am-1',
            question: '文章如何論證「心靈的解放」？',
            options: [
              'A. 通過對比手法',
              'B. 通過具體描寫',
              'C. 通過比喻論證',
              'D. 通過反證法'
            ],
            correctAnswer: 'B',
            explanation: '文章通過具體描寫西山之遊的過程和感受，生動地論證了心靈解放的主題。',
            points: 10
          },
          {
            id: 'b3-am-2',
            question: '柳宗元如何突出西山的特殊性？',
            options: [
              'A. 直接描述',
              'B. 通過對比',
              'C. 通過比喻',
              'D. 通過誇張'
            ],
            correctAnswer: 'B',
            explanation: '柳宗元通過與其他山水的對比，突出西山的特殊性和獨特魅力。',
            points: 10
          }
        ]
      },
      writingTechniques: {
        title: '寫作手法',
        questions: [
          {
            id: 'b3-wt-1',
            question: '文章主要採用什麼敘事手法？',
            options: [
              'A. 順敘',
              'B. 倒敘',
              'C. 插敘',
              'D. 平敘'
            ],
            correctAnswer: 'A',
            explanation: '文章主要採用順敘手法，按時間順序記述西山之遊的過程。',
            points: 10
          },
          {
            id: 'b3-wt-2',
            question: '柳宗元如何描寫西山？',
            options: [
              'A. 客觀描寫',
              'B. 主觀感受',
              'C. 情景交融',
              'D. 以上皆是'
            ],
            correctAnswer: 'C',
            explanation: '柳宗元採用情景交融的手法，將客觀描寫與主觀感受相結合。',
            points: 10
          }
        ]
      },
      rhetoricalDevices: {
        title: '修辭手法',
        questions: [
          {
            id: 'b3-rd-1',
            question: '「心凝形釋，與萬化冥合」運用了什麼修辭？',
            options: [
              'A. 對偶',
              'B. 排比',
              'C. 比喻',
              'D. 誇張'
            ],
            correctAnswer: 'A',
            explanation: '這句話運用了對偶修辭，結構工整，意義對應。',
            points: 10
          },
          {
            id: 'b3-rd-2',
            question: '文章中的比喻有什麼作用？',
            options: [
              'A. 增強形象性',
              'B. 突出特點',
              'C. 深化主題',
              'D. 以上皆是'
            ],
            correctAnswer: 'D',
            explanation: '比喻既能增強形象性，又能突出特點，還能深化主題。',
            points: 10
          }
        ]
      }
    }
};

// Helper functions
export const getTypeBQuizData = () => {
  return hkdseTypeBQuizData;
};

export const getTypeBQuizByType = (textId, categoryType) => {
  const quizData = hkdseTypeBQuizData[textId];
  if (!quizData) return null;

  const categoryData = quizData[categoryType];
  if (!categoryData) return null;

  // Convert questions to match the expected format
  const convertedQuestions = categoryData.questions.map(question => ({
    ...question,
    correct: question.correctAnswer.charCodeAt(0) - 65, // Convert 'A' to 0, 'B' to 1, etc.
    type: 'multiple-choice'
  }));

  return {
    title: categoryData.title,
    questions: convertedQuestions,
    timeLimit: 300, // 5 minutes
    totalPoints: categoryData.questions.reduce((sum, q) => sum + q.points, 0)
  };
};

export default hkdseTypeBQuizData;
  